import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.1",
  "description": "Turborepo 2.1 improves integration with your repository with affected package detection, and repository exploration tools.",
  "date": "2024/08/27",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.1 improves integration with your repository, with features like:"
  }, {
    "heading": "",
    "content": "Affected package graph detection: Only run tasks with changes using --affected"
  }, {
    "heading": "",
    "content": "Repository exploration tools: Find packages and tasks faster with turbo ls and turbo run"
  }, {
    "heading": "",
    "content": "Terminal UI improvements: Log selection, task search, resizing, and more"
  }, {
    "heading": "",
    "content": "Expanded configuration options: More flexibility for defaults using turbo.json"
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "Turborepo’s Remote Caching shares a single cache across all of your machines,\nso you never have to do the same work twice. But, what if you could ignore unchanged packages altogether?"
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You can now use the --affected flag with turbo run to automatically target packages with changes between the latest commit of your current branch, and the default branch of your repository (usually main or master).\nturbo will use your Package Graph to ensure tasks are run for packages with direct changes or changes to internal dependencies."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You'll want to use this flag in situations like:"
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You're running many tasks across packages in your monorepo, and only want to run those tasks in packages with code changes."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You’re not using a Remote Cache, but still want to do as little work as possible in CI."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You are using a Remote Cache, and you’re in a large repository. By minimizing the amount of tasks that will be restored from cache, there will be less data to send across the network, resulting in faster cache restoration."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "You’re already using advanced filtering techniques or turbo-ignore to create the same or similar behavior as --affected. You likely have the opportunity to simplify your scripting using this new flag."
  }, {
    "heading": "run-tasks-for-changed-packages-with---affected",
    "content": "To learn more, visit the documentation."
  }, {
    "heading": "repository-exploration-tools",
    "content": "As a repository grows and changes, it can be difficult to quickly find what you’re looking for.\nWe want to quickly surface your tasks, packages, and their relationships to make understanding your repository faster and easier."
  }, {
    "heading": "turbo-run",
    "content": "Use turbo run (with no task arguments) to get a list of the available tasks in your repository. This command also works with filters and Automatic Package Scoping."
  }, {
    "heading": "turbo-run",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "turbo-ls",
    "content": "Use turbo ls to get a list of all the packages in your repository with their locations, or filter to a specific package to see a summary of its internal dependencies and tasks.\nturbo ls also supports --filter, and --affected, making it easy to gather a list of changed packages."
  }, {
    "heading": "turbo-ls",
    "content": "turbo ls supports an experimental --output flag that can be used to return\nresults in a specific format. For example, --output=json can be used to more\neasily create inputs for other tools or custom scripts. If you were previously using\nturbo build --dry=json only to retrieve a list of changed packages,\ngive turbo ls --affected --output=json a try. Visit the docs for more information and\nleave feedback on output format on the turbo ls\nRFC."
  }, {
    "heading": "turbo-ls",
    "content": "Visit the documentation to learn more."
  }, {
    "heading": "terminal-ui-improvements",
    "content": "In Turborepo 2.0, we released a new terminal UI to improve clarity for logs and allow for interactive tasks in local development. We heard your feedback, and prioritized polishing this UI, releasing improvements in patches to 2.0 and in this 2.1 release:"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Highlighting of logs for copying to clipboard (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Search through task list (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Cleaner layout resizing when your terminal changes size (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "New icon for cache hits in task list (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Task status indicators updated when Watch Mode triggers a restart (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Output logs are respected after the terminal UI exits (PR)"
  }, {
    "heading": "terminal-ui-improvements",
    "content": "Building a great terminal UI experience has unique challenges, and we’re continuing to iterate on this experience. We appreciate your continued feedback as we keep up our work on creating great UI for monorepos."
  }, {
    "heading": "expanded-configuration-options",
    "content": "In this release, we’re adding more keys to turbo.json to give you more flexibility for your repository’s defaults. The following keys are new in this release:"
  }, {
    "heading": "expanded-configuration-options",
    "content": "You may have been using the flag equivalents for these configurations on many or all of your turbo invocations, littering your codebase with commands like:"
  }, {
    "heading": "expanded-configuration-options",
    "content": "These can now be simplified with a centralized configuration in turbo.json using Turborepo’s existing configuration model:"
  }, {
    "heading": "expanded-configuration-options",
    "content": "turbo.json sets the defaults for your repository."
  }, {
    "heading": "expanded-configuration-options",
    "content": "System environment variables customize behavior in a specific environment."
  }, {
    "heading": "expanded-configuration-options",
    "content": "Flags customize behavior for specific invocations of turbo."
  }, {
    "heading": "expanded-configuration-options",
    "content": "To learn more about available options and configurations, visit the documentation."
  }, {
    "heading": "other-improvements",
    "content": "We’d like to especially thank Shaharking for their contribution in #9023 to make the colors for task names in streamed UIs deterministic, closing #2564. This makes it easier to compare tasks across turbo run invocations."
  }, {
    "heading": "other-improvements",
    "content": "View the full changelog at vercel/turborepo."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 2.0 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "25.9k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "2.9M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "428 years of compute time saved through Remote Caching on Vercel"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "run-tasks-for-changed-packages-with---affected",
    "content": "Run tasks for changed packages with --affected"
  }, {
    "id": "repository-exploration-tools",
    "content": "Repository exploration tools"
  }, {
    "id": "turbo-run",
    "content": "turbo run"
  }, {
    "id": "turbo-ls",
    "content": "turbo ls"
  }, {
    "id": "terminal-ui-improvements",
    "content": "Terminal UI Improvements"
  }, {
    "id": "expanded-configuration-options",
    "content": "Expanded configuration options"
  }, {
    "id": "other-improvements",
    "content": "Other improvements"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#run-tasks-for-changed-packages-with---affected",
  title: _jsxs(_Fragment, {
    children: ["Run tasks for changed packages with ", _jsx("code", {
      children: "--affected"
    })]
  })
}, {
  depth: 2,
  url: "#repository-exploration-tools",
  title: _jsx(_Fragment, {
    children: "Repository exploration tools"
  })
}, {
  depth: 3,
  url: "#turbo-run",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "turbo run"
    })
  })
}, {
  depth: 3,
  url: "#turbo-ls",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "turbo ls"
    })
  })
}, {
  depth: 2,
  url: "#terminal-ui-improvements",
  title: _jsx(_Fragment, {
    children: "Terminal UI Improvements"
  })
}, {
  depth: 2,
  url: "#expanded-configuration-options",
  title: _jsx(_Fragment, {
    children: "Expanded configuration options"
  })
}, {
  depth: 2,
  url: "#other-improvements",
  title: _jsx(_Fragment, {
    children: "Other improvements"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.1"
    }), "\n", "\n", _jsx(Date, {
      children: "Tuesday, August 27th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['tomknickman', 'anthonyshew', 'chrisolszewski', 'nicholasyang', 'dimitrimitropoulos']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.1 improves integration with your repository, with features like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#run-tasks-for-changed-packages-with---affected",
          children: _jsx(_components.strong, {
            children: "Affected package graph detection"
          })
        }), ": Only run tasks with changes using ", _jsx(_components.code, {
          children: "--affected"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#repository-exploration-tools",
          children: _jsx(_components.strong, {
            children: "Repository exploration tools"
          })
        }), ": Find packages and tasks faster with ", _jsx(_components.code, {
          children: "turbo ls"
        }), " and ", _jsx(_components.code, {
          children: "turbo run"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#terminal-ui-improvements",
          children: _jsx(_components.strong, {
            children: "Terminal UI improvements"
          })
        }), ": Log selection, task search, resizing, and more"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#expanded-configuration-options",
          children: _jsx(_components.strong, {
            children: "Expanded configuration options"
          })
        }), ": More flexibility for defaults using ", _jsx(_components.code, {
          children: "turbo.json"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "run-tasks-for-changed-packages-with---affected",
      children: ["Run tasks for changed packages with ", _jsx(_components.code, {
        children: "--affected"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo’s ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), " shares a single cache across all of your machines,\nso you never have to do the same work twice. But, what if you could ignore unchanged packages altogether?"]
    }), "\n", _jsxs(_components.p, {
      children: ["You can now use the ", _jsx(_components.code, {
        children: "--affected"
      }), " flag with ", _jsx(_components.code, {
        children: "turbo run"
      }), " to automatically target packages with changes between the latest commit of your current branch, and the default branch of your repository (usually ", _jsx(_components.code, {
        children: "main"
      }), " or ", _jsx(_components.code, {
        children: "master"
      }), ").\n", _jsx(_components.code, {
        children: "turbo"
      }), " will use your ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), " to ensure tasks are run for packages with direct changes or changes to internal dependencies."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "You'll want to use this flag in situations like:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "You're running many tasks across packages in your monorepo, and only want to run those tasks in packages with code changes."
      }), "\n", _jsxs(_components.li, {
        children: ["You’re ", _jsx(_components.em, {
          children: "not"
        }), " using a Remote Cache, but still want to do as little work as possible in CI."]
      }), "\n", _jsxs(_components.li, {
        children: ["You ", _jsx(_components.em, {
          children: "are"
        }), " using a Remote Cache, and you’re in a large repository. By minimizing the amount of tasks that will be restored from cache, there will be less data to send across the network, resulting in faster cache restoration."]
      }), "\n", _jsxs(_components.li, {
        children: ["You’re already using ", _jsx(_components.a, {
          href: "/docs/reference/run#advanced-filtering-examples",
          children: "advanced filtering techniques"
        }), " or ", _jsx(_components.a, {
          href: "/docs/reference/turbo-ignore",
          children: _jsx(_components.code, {
            children: "turbo-ignore"
          })
        }), " to create the same or similar behavior as ", _jsx(_components.code, {
          children: "--affected"
        }), ". You likely have the opportunity to simplify your scripting using this new flag."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more, ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "repository-exploration-tools",
      children: "Repository exploration tools"
    }), "\n", _jsx(_components.p, {
      children: "As a repository grows and changes, it can be difficult to quickly find what you’re looking for.\nWe want to quickly surface your tasks, packages, and their relationships to make understanding your repository faster and easier."
    }), "\n", _jsx(_components.h3, {
      id: "turbo-run",
      children: _jsx(_components.code, {
        children: "turbo run"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "turbo run"
      }), " (with no task arguments) to get a list of the available tasks in your repository. This command also works with ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#using-filters",
        children: "filters"
      }), " and ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#automatic-package-scoping",
        children: "Automatic Package Scoping"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List all tasks in the repository"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List tasks in a specific package"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@repo/ui"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Using Automatic Package Scoping"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "cd"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " packages/ui"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: " &&"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/run",
        children: "Visit the documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h3, {
      id: "turbo-ls",
      children: _jsx(_components.code, {
        children: "turbo ls"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "turbo ls"
      }), " to get a list of all the packages in your repository with their locations, or filter to a specific package to see a summary of its internal dependencies and tasks.\n", _jsx(_components.code, {
        children: "turbo ls"
      }), " also supports ", _jsx(_components.code, {
        children: "--filter"
      }), ", and ", _jsx(_components.code, {
        children: "--affected"
      }), ", making it easy to gather a list of changed packages."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List all packages in the repository"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# List dependencies and tasks for the `web` package"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "## List affected packages"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ls"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo ls"
        }), " supports an experimental ", _jsx(_components.code, {
          children: "--output"
        }), " flag that can be used to return\nresults in a specific format. For example, ", _jsx(_components.code, {
          children: "--output=json"
        }), " can be used to more\neasily create inputs for other tools or custom scripts. If you were previously using\n", _jsx(_components.code, {
          children: "turbo build --dry=json"
        }), " ", _jsx(_components.em, {
          children: "only"
        }), " to retrieve a list of changed packages,\ngive ", _jsx(_components.code, {
          children: "turbo ls --affected --output=json"
        }), " a try. Visit the docs for more information and\nleave feedback on output format on the ", _jsx(_components.code, {
          children: "turbo ls"
        }), "\n", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/discussions/8811",
          children: "RFC"
        }), "."]
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/ls",
        children: "Visit the documentation"
      }), " to learn more."]
    }), "\n", _jsx(_components.h2, {
      id: "terminal-ui-improvements",
      children: "Terminal UI Improvements"
    }), "\n", _jsxs(_components.p, {
      children: ["In Turborepo 2.0, we released a ", _jsx(_components.a, {
        href: "https://turborepo.com/blog/turbo-2-0#new-terminal-ui",
        children: "new terminal UI"
      }), " to improve clarity for logs and allow for interactive tasks in local development. We heard your feedback, and prioritized polishing this UI, releasing improvements in patches to 2.0 and in this 2.1 release:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Highlighting of logs for copying to clipboard (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8713",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Search through task list (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/9042",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Cleaner layout resizing when your terminal changes size (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8996",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["New icon for cache hits in task list (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8869",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Task status indicators updated when Watch Mode triggers a restart (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8960",
          children: "PR"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: ["Output logs are respected after the terminal UI exits (", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/8612",
          children: "PR"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Building a great terminal UI experience has unique challenges, and we’re continuing to iterate on this experience. We appreciate your continued feedback as we keep up our work on creating great UI for monorepos."
    }), "\n", _jsx(_components.h2, {
      id: "expanded-configuration-options",
      children: "Expanded configuration options"
    }), "\n", _jsxs(_components.p, {
      children: ["In this release, we’re adding more keys to ", _jsx(_components.code, {
        children: "turbo.json"
      }), " to give you more flexibility for your repository’s defaults. The following keys are new in this release:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"envMode\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"loose\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"daemon\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"cacheDir\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./my-custom-directory/\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["You may have been using the flag equivalents for these configurations on many or all of your ", _jsx(_components.code, {
        children: "turbo"
      }), " invocations, littering your codebase with commands like:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-daemon"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache-dir=./my-custom-directory"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["These can now be simplified with a centralized configuration in ", _jsx(_components.code, {
        children: "turbo.json"
      }), " using Turborepo’s existing configuration model:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), " sets the defaults for your repository."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "System environment variables"
        }), " customize behavior in a specific environment."]
      }), "\n", _jsxs(_components.li, {
        children: ["Flags customize behavior for specific invocations of ", _jsx(_components.code, {
          children: "turbo"
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about available options and configurations, ", _jsx(_components.a, {
        href: "/docs/reference/configuration",
        children: "visit the documentation"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "other-improvements",
      children: "Other improvements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["We’d like to especially thank ", _jsx(_components.a, {
          href: "https://github.com/Shaharking",
          children: "Shaharking"
        }), " for their contribution in ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/pull/9023",
          children: "#9023"
        }), " to make the colors for task names in streamed UIs deterministic, closing ", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/issues/2564",
          children: "#2564"
        }), ". This makes it easier to compare tasks across ", _jsx(_components.code, {
          children: "turbo run"
        }), " invocations."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["View the full changelog at ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/releases/tag/v2.1.0",
        children: _jsx(_components.code, {
          children: "vercel/turborepo"
        })
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-2-0",
        children: "Turborepo 2.0"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "25.9k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "2.9M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["428 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team."
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
